export const works = [
  {
    id: 1,
    title: "MERN stack blog app",
    url: "https://tatsumernblogapp.herokuapp.com/posts",
    description:
      "This is a MERN stack blog app with authentication You can create, edit, delete, update a blog post which means this is a CRUD app with safety authentication",
    image:
      "https://cdn-ak.f.st-hatena.com/images/fotolife/K/Kenkentan/20220303/20220303140333.png",
    skills: "MongoDB, Express, React, Node.js, Material-Ui",
  },
  {
    id: 2,
    title: "Node.js blog app",
    url: "https://tatsumernblogapp.herokuapp.com/",
    description:
      "This is Node.js blog app using MongoDB, Express, EJS, and Node.js You can create, edit, delete, update a blog post which means this is a CRUD app",
    image:
      "https://cdn-ak.f.st-hatena.com/images/fotolife/K/Kenkentan/20220303/20220303140329.png",
    skills: "MongoDB, Express, EJS, Node.js, Bootstrap",
  },
  {
    id: 3,
    title: "CRUD issue table",
    url: "https://trusting-bhaskara-e10bb6.netlify.app",
    description:
      "This is a CRUD app You can Create, Read, Update, Delete issues",
    image:
      "https://cdn-ak.f.st-hatena.com/images/fotolife/K/Kenkentan/20220303/20220303140322.png",
    skills: "React, Redux, Material-Ui, Sass",
  },
  {
    id: 4,
    title: "React Moive Database App",
    url: "https://vigorous-hoover-091bd5.netlify.app",
    description:
      "This is a React movie search app You can search movies and trending movies are showed up on the home page",
    image:
      "https://cdn-ak.f.st-hatena.com/images/fotolife/K/Kenkentan/20220303/20220303140407.png",
    skills: "React, React-router-dom, Context, Sass",
  },
  {
    id: 5,
    title: "React Weather App",
    url: "https://boisterous-gaufre-15ea4c.netlify.app",
    description:
      "This is a React weather app You can search weather at the location you type. Using open weather api",
    image:
      "https://cdn-ak.f.st-hatena.com/images/fotolife/K/Kenkentan/20220430/20220430021835.png",
    skills: "React, API",
  },
  {
    id: 6,
    title: "React Netflix clone",
    url: "https://chic-biscochitos-0263c6.netlify.app",
    description: "This is a netflix clone site by react and firebase",
    image:
      "https://cdn-ak.f.st-hatena.com/images/fotolife/K/Kenkentan/20220430/20220430022103.png",
    skills: "React, React-router-dom, styled-components, firebase",
  },
  {
    id: 7,
    title: "House marketplace app",
    url: "https://stellar-dusk-05f8d6.netlify.app",
    description:
      "This is a house marketplace CRUD application using react and firebase",
    image:
      "https://cdn-ak.f.st-hatena.com/images/fotolife/K/Kenkentan/20220430/20220430022311.png",
    skills: "React, React-router-dom, Context, Sass",
  },
  {
    id: 8,
    title: "eCommerce app",
    url: "https://comforting-malabi-102f84.netlify.app/",
    description:
      "This is a house marketplace CRUD application using react and firebase",
    image:
      "https://cdn-ak.f.st-hatena.com/images/fotolife/K/Kenkentan/20220430/20220430022414.png",
    skills: "React, React-router-dom, Context, Sass",
  },
  {
    id: 9,
    title: "github finder app",
    url: "https://resplendent-torte-886e11.netlify.app",
    description:
      "Enter a name and you will be searched among GITHUB users. You can also browse details.",
    image:
      "https://cdn-ak.f.st-hatena.com/images/fotolife/K/Kenkentan/20220430/20220430023007.png",
    skills: "React, React-router-dom, Context, Sass",
  },
];
